<template>
	<div>
		<div class="content">
			<!-- 轮播表 -->
			<div id="carouselList">
				<div v-if="isShow">
					<dv-scroll-board :config="config" class="scrollBoard" />
					<div id="activeBg"></div>
				</div>

				<div v-else>
					<img src="../../common/img/nothing.png" alt="" style="width: 8.5rem;height: 7.9375rem;">
				</div>
			</div>
			<!-- 轮播表 -->
		</div>
	</div>
</template>
<script>
	import {
		apiurl,
		imgurl
	} from '../../common/js/baseApi.js'
	import axios from 'axios'
	export default {
		components: {},
		data() {
			return {
				pId: '', // 用户id
				config: {},
				nowClientWidth: 1920, // 默认屏幕宽度
				isShow: true
			}
		},
		computed: {},
		watch: {},
		methods: {
			getDataList() {
				axios.get(apiurl + '/repair/dataList', {
						params: {
							pId: this.pId,
							pageNum: 1,
							pageSize: 10
						}
					})
					.then(data => {
						if (data.data.status != 1) {
							return this.isShow = false
						}
						let res = data.data.data
						if (res.length == 0) {
							return this.isShow = false
						}
						let arr = []
						res.rows.forEach((item) => {
							let status = ''
							switch (item.status) {
								case 0:
									status = '未派工'
									break;
								case 1:
									status = '已派工'
									break;
								case 2:
									status = '已挂单'
									break;
								case 3:
									status = '待审核'
									break;
								case 4:
									status = '已审核'
									break;
							}
							arr.push([item.createTime, item.create_by, item.riskName, item.levalName, item
								.user_name, status
							])
						})

						this.config = {
							header: ['反馈时间', '反馈人', '名称', '等级', '处理人', '处理状态'],
							data: [],
							columnWidth: [this.nowSize(160), this.nowSize(100), this.nowSize(190), this.nowSize(
								100), this.nowSize(90), this.nowSize(100)],
							align: ['center', 'center', 'center', 'center', 'center', 'center'],
							rowNum: 4,
							headerBGC: 'rgba(0, 44, 81,0)',
							headerHeight: this.nowSize(48),
							oddRowBGC: 'rgba(0, 44, 81, 0)',
							evenRowBGC: 'rgba(10, 29, 50, 0)'
						}

						this.config.data = arr
					})
					.catch(err => {

					})
			},
			nowSize(val, initWidth = 1920) {
				return val * (this.nowClientWidth / initWidth);
			}
		},
		created() {},
		mounted() {
			this.nowClientWidth = document.documentElement.clientWidth;
			var url = window.location.search;
			var theRequest = new Object();
			if (url.indexOf("?") != -1) {
				var str = url.split('?')[1];
				var strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
				}
			}
			this.pId = theRequest.pId
			this.getDataList()
		},
		beforeCreate() {},
		beforeMount() {},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		activated() {},
	}
</script>
<style lang='scss' scoped>
	.content {
		position: relative;
		width: 50.5625rem;
		height: 14.6875rem;
		display: flex;
		align-items: center;
		justify-content: center;

		/* 轮播表 */
		#carouselList {
			position: relative;
			width: 49rem;
			height: 15.9375rem;
			background: url(../../common/img/centerBottom/bg.png) 0 0 no-repeat;
			background-size: 100% 100%;
			display: flex;
			align-items: center;
			justify-content: center;

			>>>.scrollBoard {
				width: 46.25rem;
				height: 12.75rem;
				font-size: 1rem;

				.header {
					.header-item {
						font-size: 0.875rem;
					}
				}

				.rows {
					.row-item {
						font-size: 0.875rem;
					}
				}
			}

			#activeBg {
				position: absolute;
				top: 4.8rem;
				left: 1.25rem;
				width: 46.25rem;
				height: 1.875rem;
				background: url(../../common/img/centerBottom/firstLine.png) 0 0 no-repeat;
				background-size: 100% 100%;
			}
		}

		/* 轮播表 */
	}
</style>



// WEBPACK FOOTER //
// src/components/centerBottom/index.vue